import CoachAuthContainer from '@/components/CoachAuthContainer/CoachAuthContainer';
import DirectorAuthContainer from '@/components/DirectorAuthContainer/DirectorAuthContainer';
import {roleType} from '@/constants/constants';
import {Helmet} from 'react-helmet';
import {Outlet} from 'react-router-dom';
import AuthContainer from '../components/AuthContainer/AuthContainer';

export default function CoachDirectorLayout({role}: {role: string}) {
  const RoleBasedAuthContainer = role === roleType.teamCoach ? CoachAuthContainer : DirectorAuthContainer;
  return (
    <>
      <Helmet>
        <title>MyTOCA | {role} View</title>
      </Helmet>
      <AuthContainer>
        <RoleBasedAuthContainer>
          <Outlet />
        </RoleBasedAuthContainer>
      </AuthContainer>
    </>
  );
}
